import type { ReactNode } from 'react';
import './LegalPage.css';

export type LegalBlock =
  | { kind: 'p'; text: ReactNode }
  | { kind: 'ul'; items: string[] };

export interface LegalSection {
  heading: string;
  blocks: LegalBlock[];
}

/**
 * The shape all three legal pages share.
 *
 * Forced to LTR whatever the app's language is, because the text is English
 * and only English. An English paragraph laid out right to left is unreadable,
 * and these are the documents people are held to.
 */
export function LegalPage({
  title,
  updated,
  sections,
  back
}: {
  title: string;
  updated: string;
  sections: LegalSection[];
  back: ReactNode;
}) {
  return (
    <article className="legal-page" dir="ltr" lang="en">
      <header className="legal-page-header">
        {back}
        <h1>{title}</h1>
        <p className="legal-page-updated">Last updated: <bdi>{updated}</bdi></p>
      </header>
      {sections.map(section => (
        <section key={section.heading}>
          <h2>{section.heading}</h2>
          {section.blocks.map((block, index) => (
            block.kind === 'p'
              ? <p key={index}>{block.text}</p>
              : (
                <ul key={index}>
                  {block.items.map(item => <li key={item}>{item}</li>)}
                </ul>
              )
          ))}
        </section>
      ))}
    </article>
  );
}
